import { ChangeReason } from '@/services/compensation';

const MONTHLY_HOURLY_RATE = 160;

export const changeReasonOptions: ChangeReason[] = [
  'Promotion',
  'Merit',
  'Adjust',
  'Initial Compensation',
  'Other',
];

export const calcHourlyRateFromMonthlyPayment = (monthlyPayment: string): string => {
  if (!monthlyPayment) return '';
  const hourlyRate = (Number(monthlyPayment) / MONTHLY_HOURLY_RATE).toFixed(2);
  return String(hourlyRate);
};
